import type { LocaleMessages } from '../../types/i18n'
import common from './common.json'
import auth from './auth.json'
import forms from './forms.json'
import subscription from './subscription.json'
import manageSubscription from './manageSubscription.json'
import admin from './admin.json'
import errors from './errors.json'

export const en: LocaleMessages = {
  common,
  auth,
  forms,
  subscription,
  manageSubscription,
  admin,
  errors,
}

export default en
